let language = {
    USER_AUTHORIZE_OR_TEXT: "或",
    USER_AUTHORIZE_FORM_EMAIL_LABEL: "电子邮箱",
    USER_AUTHORIZE_FORM_EMAIL_PLACEHOLDER: "请输入您的电子邮箱地址",
    USER_AUTHORIZE_FORM_EMAIL_ERROR_TIP1: "请输入正确的电子邮箱地址",
    USER_AUTHORIZE_FORM_PASSWORD_LABEL: "密码",
    USER_AUTHORIZE_FORM_PASSWORD_PLACEHOLDER: "请输入您的密码",
    USER_AUTHORIZE_FORM_SUBMIT_BTN: "登录",
    
    USER_AUTHORIZE_CONNECTION_FAIL_ALERT_TITLE: "连接失败",
};

export { language }